import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MapPin, X, ExternalLink } from "lucide-react";
import api from "../lib/api";

// Notifikasi "teknisi sudah tiba di lokasi" dari absensi.deteksipipabocor.com
// (teknisi berada dalam radius Pengaturan › arrival_radius_m dari titik share loc customer).
// Sengaja non-modal (pojok kanan bawah) supaya tidak mengganggu pekerjaan admin.
const fmtJam = (iso) => {
  try { return new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" }); } catch (_) { return ""; }
};
const fmtJarak = (m) => (m == null ? "" : m >= 1000 ? `${(m / 1000).toFixed(1).replace(".", ",")} km` : `${m} m`);

const TechArrivalPopup = () => {
  const nav = useNavigate();
  const location = useLocation();
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    api.get("/tech-arrivals/pending").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const iv = setInterval(load, 20000);
    return () => clearInterval(iv);
  }, [load]);

  const ack = async (a) => {
    setItems((prev) => prev.filter((x) => x.id !== a.id));
    try { await api.post(`/tech-arrivals/${a.id}/ack`); } catch (_) { /* noop */ }
  };

  const ackAll = async () => {
    setItems([]);
    try { await api.post("/tech-arrivals/ack-all"); } catch (_) { /* noop */ }
  };

  const openOrder = async (a) => {
    await ack(a);
    const url = `/orders?open=${encodeURIComponent(a.order_id)}`;
    // Halaman Order hanya membaca ?open= saat dimuat, jadi reload penuh jika sudah di /orders
    if (location.pathname === "/orders") window.location.assign(url);
    else nav(url);
  };

  if (!items.length) return null;
  const shown = items.slice(-3).reverse(); // terbaru di atas

  return (
    <div className="fixed bottom-4 right-4 z-[55] w-[calc(100%-2rem)] max-w-sm space-y-2" data-testid="tech-arrival-popup">
      {shown.map((a) => (
        <div key={a.id} className="bg-white border-2 border-[#0284C7] shadow-xl">
          <div className="flex items-center justify-between px-3 py-2 bg-[#0284C7] text-white">
            <div className="flex items-center gap-2 font-heading font-bold text-sm">
              <MapPin size={16} /> Teknisi Tiba di Lokasi
            </div>
            <button onClick={() => ack(a)} className="p-1 hover:bg-white/20" aria-label="Tutup" data-testid="tech-arrival-close"><X size={16} /></button>
          </div>
          <div className="px-3 py-2 text-sm space-y-1">
            <p>
              <span className="font-bold">{a.technician_name}</span> sudah tiba di lokasi{" "}
              <span className="font-bold">{a.customer_name || "customer"}</span>
              {a.customer_city ? <> ({a.customer_city})</> : null} · order{" "}
              <span className="font-mono font-bold text-[#002FA7]">{a.order_no}</span>
            </p>
            <p className="text-xs text-[#52525B] font-mono">
              {fmtJam(a.arrived_at)} WIB · jarak {fmtJarak(a.distance_m)} dari titik customer{a.auto ? " · otomatis" : ""}
            </p>
          </div>
          <div className="flex gap-2 px-3 pb-3">
            <button onClick={() => openOrder(a)} data-testid="tech-arrival-open"
              className="flex-1 inline-flex items-center justify-center gap-1 bg-[#002FA7] text-white px-2 py-1.5 text-[11px] font-bold uppercase tracking-wider hover:bg-[#002FA7]/90">
              <ExternalLink size={12} /> Buka Order
            </button>
            {a.lat != null && a.lng != null && (
              <a href={`https://maps.google.com/?q=${a.lat},${a.lng}`} target="_blank" rel="noreferrer"
                className="px-2 py-1.5 text-[11px] font-bold uppercase tracking-wider border border-[#E4E4E7] hover:bg-[#F4F4F5]">
                Lokasi Teknisi
              </a>
            )}
          </div>
        </div>
      ))}
      {items.length > 1 && (
        <div className="flex justify-end gap-2 items-center">
          {items.length > 3 && <span className="text-xs text-[#52525B] bg-white px-2 py-1 border border-[#E4E4E7]">+{items.length - 3} lainnya</span>}
          <button onClick={ackAll} className="text-xs font-bold uppercase tracking-wider bg-white px-2 py-1 border border-[#E4E4E7] hover:bg-[#F4F4F5]">
            Tutup semua
          </button>
        </div>
      )}
    </div>
  );
};

export default TechArrivalPopup;
